import { render } from "./Radio.vue?vue&type=template&id=cc8e9c1e&ts=true"
import script from "./Radio.vue?vue&type=script&lang=ts"
export * from "./Radio.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__